import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import type { Room } from "@/react/types/Live/Room";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { usePunditUserContext } from "@circle-react/contexts";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { publicLiveStreams } from "@circle-react/helpers/urlHelpers";
import { getRoomRefetchInterval } from "../helpers";

export const usePublicLiveStreamRoom = () => {
  const { roomSlug } = useParams<{ roomSlug: string }>();
  const { currentCommunity, isLoading: isCommunityLoading } =
    usePunditUserContext();

  const [refetchInterval, setRefetchInterval] = useState<number | null>(null);
  const {
    data: room,
    isLoading,
    isError,
    error,
    refetch: refetchRoom,
    ...passThroughProps
  } = useQuery<Room, ApiError>(
    ["public-live-stream", "room", roomSlug, currentCommunity?.id],
    () =>
      reactQueryGet(
        publicLiveStreams.rooms.show({
          slug: roomSlug,
          params: {
            community_id: currentCommunity?.id,
          },
        }),
      ),
    {
      enabled: !isCommunityLoading && Boolean(roomSlug),
      refetchInterval: refetchInterval || false,
    },
  );
  useEffect(() => setRefetchInterval(getRoomRefetchInterval(room)), [room]);

  return {
    room,
    isLoading,
    isError,
    error,
    refetchRoom,
    ...passThroughProps,
  };
};
